export const prodImageHost = 'https://i.lmpm.com'
export const stagingImageHost = 'https://i.lmpm.io'
export const devImageHost = 'https://i.lmpm.dev'

export const prodS3CompanyBucket = 'lmpm-company-store-prod'
export const devS3CompanyBucket = 'lmpm-company-store-dev'
